<app-toast />

<section class="configuracoes-comissoes">
    <app-card-content [border]="false" icon="pi pi-cog" title="Configurações de Comissões" subtitle="Parâmetros de configuração e modelos de ata">
        <div card-header class="flex items-center gap-2">
            <button type="button" pButton icon="pi pi-refresh" label="Carregar" severity="secondary" [outlined]="true" [loading]="carregando()" (click)="carregarConfiguracao()"></button>
            <button type="button" pButton [appCan]="roleEditar" icon="pi pi-save" label="Salvar" [loading]="salvando()" (click)="salvarConfiguracao()"></button>
        </div>

        <div class="flex flex-col md:flex-row md:items-end justify-between gap-5 p-5 mb-6 rounded-xl bg-surface-50 dark:bg-surface-800/40 border border-surface-100 dark:border-surface-700 shadow-sm">
            <div class="flex flex-col gap-1.5 min-w-[280px]">
                <label for="idEstruturaOrganizacional" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Estrutura Organizacional</label>
                <div class="flex gap-2">
                    <input id="idEstruturaOrganizacional" pInputText class="flex-1" [value]="estruturaLabel()" readonly placeholder="Nenhuma estrutura selecionada" aria-label="Estrutura organizacional selecionada" />
                    <button type="button" pButton [appCan]="roleEditar" icon="pi pi-search" severity="primary" [outlined]="true" (click)="abrirSeletorEstrutura()" aria-label="Localizar estrutura organizacional"></button>
                </div>
            </div>

            <div class="flex items-center gap-3 flex-wrap">
                <div class="contador-config">
                    <span>{{ modelosAtivosCount() }}</span>
                    <small>Modelos ativos</small>
                </div>
                <div class="contador-config">
                    <span>{{ documentoDisponivelCount() }}</span>
                    <small>Documentos</small>
                </div>
                <div class="contador-config">
                    <span>{{ locaisAtivosCount() }}</span>
                    <small>Locais ativos</small>
                </div>
            </div>
        </div>

        <div class="flex justify-between items-center mb-6">
            <div class="mx-auto">
                <p-selectbutton [options]="abas" [ngModel]="abaAtiva()" (ngModelChange)="abaAtiva.set($event)" optionLabel="label" optionValue="value" [unselectable]="true" class="flex flex-wrap justify-center gap-2" styleClass="w-33">
                    <ng-template let-option pTemplate="item">
                        <div class="flex items-center">
                            <span>{{ option.label }}</span>
                        </div>
                    </ng-template>
                </p-selectbutton>
            </div>
        </div>

        @if (abaAtiva() === 'geral') {
            <div class="grid-configuracao">
                <app-card-content [icon]="'pi pi-clock'" [title]="'Ata'" [subtitle]="'Autosave e assunto vinculado à ata'">
                    <div class="linha-toggle p-3.5 rounded-xl bg-surface-50 dark:bg-surface-800/40 border border-surface-100 dark:border-surface-700">
                        <div class="flex flex-col gap-0.5">
                            <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Autosave</label>
                            <span class="text-xs font-semibold text-surface-600 dark:text-surface-300">{{ form().autosave ? 'Ativo' : 'Inativo' }}</span>
                        </div>
                        <p-toggleswitch inputId="autosave" [ngModel]="form().autosave" (ngModelChange)="patchForm('autosave', $event)"></p-toggleswitch>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                        <div class="flex flex-col gap-1.5">
                            <label for="temporizadorAutosave" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Intervalo em minutos</label>
                            <p-inputnumber
                                inputId="temporizadorAutosave"
                                [ngModel]="form().temporizadorAutosave"
                                (ngModelChange)="patchForm('temporizadorAutosave', $event)"
                                [useGrouping]="false"
                                [min]="1"
                                [max]="99"
                                [disabled]="!form().autosave"
                                styleClass="w-full"
                                inputStyleClass="w-full"
                            ></p-inputnumber>
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="idAssuntoAta" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Assunto da ata</label>
                            <div class="flex gap-2">
                                <input id="idAssuntoAta" pInputText class="flex-1" [value]="assuntoAtaLabel()" readonly placeholder="Nenhum assunto selecionado" aria-label="Assunto da ata selecionado" />
                                <button type="button" pButton [appCan]="roleEditar" icon="pi pi-search" severity="primary" [outlined]="true" (click)="abrirSeletorAssunto()" aria-label="Localizar assunto"></button>
                            </div>
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [icon]="'pi pi-user-edit'" [title]="'Assinante'" [subtitle]="'Cargo e responsável pela assinatura'">
                    <div class="flex flex-col gap-1.5 mb-4">
                        <label for="cargoAssinante" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Cargo assinante</label>
                        <p-select
                            inputId="cargoAssinante"
                            [options]="cargosAssinante()"
                            optionLabel="dsCargo"
                            optionValue="idCargo"
                            [ngModel]="form().idCargoAssinante"
                            (ngModelChange)="selecionarCargoAssinante($event)"
                            [loading]="carregandoCargos()"
                            [showClear]="true"
                            appendTo="body"
                            placeholder="Selecione"
                            styleClass="w-full"
                        ></p-select>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div class="flex flex-col gap-1.5 sm:col-span-2">
                            <label for="nmSolicitanteAssinante" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Assinante</label>
                            <input id="nmSolicitanteAssinante" pInputText [ngModel]="form().nmSolicitanteAssinante" [disabled]="true" />
                        </div>
                        <div class="flex flex-col gap-1.5">
                            <label for="ufSgUfAssinante" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">UF</label>
                            <input id="ufSgUfAssinante" pInputText [ngModel]="form().ufSgUfAssinante" [disabled]="true" class="uppercase" />
                        </div>
                    </div>
                    <small class="block mt-3 text-xs text-muted-color"> Código do solicitante: {{ form().idSolicitanteAssinante || '-' }} </small>
                </app-card-content>
            </div>
        }

        @if (abaAtiva() === 'emails') {
            <div class="grid-configuracao">
                <app-card-content [icon]="'pi pi-envelope'" [title]="'Textos dos e-mails'" [subtitle]="'Cópias, títulos e corpos das mensagens'" class="col-span-full">
                    <div class="grade-checks mb-5">
                        <div class="linha-toggle mini-toggle">
                            <span>Copiar convocações</span>
                            <p-toggleswitch [ngModel]="form().copiaConvocacoes" (ngModelChange)="patchForm('copiaConvocacoes', $event)"></p-toggleswitch>
                        </div>
                        <div class="linha-toggle mini-toggle">
                            <span>Copiar convites</span>
                            <p-toggleswitch [ngModel]="form().copiaConvites" (ngModelChange)="patchForm('copiaConvites', $event)"></p-toggleswitch>
                        </div>
                        <div class="linha-toggle mini-toggle">
                            <span>Copiar oficiados</span>
                            <p-toggleswitch [ngModel]="form().copiaConvitesOficiados" (ngModelChange)="patchForm('copiaConvitesOficiados', $event)"></p-toggleswitch>
                        </div>
                        <div class="linha-toggle mini-toggle">
                            <span>Copiar cancelamentos</span>
                            <p-toggleswitch [ngModel]="form().copiaCancelamentos" (ngModelChange)="patchForm('copiaCancelamentos', $event)"></p-toggleswitch>
                        </div>
                    </div>

                    <div class="flex flex-col gap-1.5 mb-5">
                        <label for="nmEmailsCopia" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">E-mails para copia</label>
                        <input id="nmEmailsCopia" pInputText [ngModel]="form().nmEmailsCopia" (ngModelChange)="patchForm('nmEmailsCopia', $event)" maxlength="160" />
                    </div>

                    <div class="templates-email">
                        <div class="email-template">
                            <label for="tituloEmailConvocacoes">Título de convocações</label>
                            <input id="tituloEmailConvocacoes" pInputText [ngModel]="form().tituloEmailConvocacoes" (ngModelChange)="patchForm('tituloEmailConvocacoes', $event)" maxlength="100" />
                            <button
                                type="button"
                                pButton
                                [appCan]="roleEditar"
                                icon="pi pi-pencil"
                                label="Editar corpo do e-mail"
                                severity="secondary"
                                [outlined]="true"
                                (click)="abrirEditorEmail('corpoEmailConvocacoes', 'Corpo do e-mail de convocacoes')"
                            ></button>
                        </div>
                        <div class="email-template">
                            <label for="tituloEmailConvites">Título de convites</label>
                            <input id="tituloEmailConvites" pInputText [ngModel]="form().tituloEmailConvites" (ngModelChange)="patchForm('tituloEmailConvites', $event)" maxlength="100" />
                            <button
                                type="button"
                                pButton
                                [appCan]="roleEditar"
                                icon="pi pi-pencil"
                                label="Editar corpo do e-mail"
                                severity="secondary"
                                [outlined]="true"
                                (click)="abrirEditorEmail('corpoEmailConvites', 'Corpo do e-mail de convites')"
                            ></button>
                        </div>
                        <div class="email-template">
                            <label for="tituloEmailCancelamentos">Título de cancelamentos</label>
                            <input id="tituloEmailCancelamentos" pInputText [ngModel]="form().tituloEmailCancelamentos" (ngModelChange)="patchForm('tituloEmailCancelamentos', $event)" maxlength="100" />
                            <button
                                type="button"
                                pButton
                                [appCan]="roleEditar"
                                icon="pi pi-pencil"
                                label="Editar corpo do e-mail"
                                severity="secondary"
                                [outlined]="true"
                                (click)="abrirEditorEmail('corpoEmailCancelamentos', 'Corpo do e-mail de cancelamentos')"
                            ></button>
                        </div>
                    </div>
                </app-card-content>
            </div>
        }

        @if (abaAtiva() === 'locais') {
            <app-card-content [icon]="'pi pi-map-marker'" [title]="'Locais de reuniao'" [subtitle]="'Locais internos e externos para reuniões'" class="col-span-full">
                <div card-header class="flex items-center gap-2">
                    <button type="button" pButton icon="pi pi-refresh" severity="secondary" [outlined]="true" [loading]="carregandoLocais()" (click)="carregarLocaisReuniao()" aria-label="Recarregar locais"></button>
                    <button type="button" pButton icon="pi pi-plus" label="Novo" [appCan]="roleGerenciarLocais" (click)="abrirNovoLocal()"></button>
                </div>

                <!-- Filtros -->
                <app-filtros-bar (limpar)="limparFiltrosLocais()" (filtrar)="aplicarFiltrosLocais()">
                    <app-filtro-campo label="Local" [wide]="true" inputId="filtro-local-texto">
                        <input
                            id="filtro-local-texto"
                            pInputText
                            type="text"
                            class="w-full"
                            [ngModel]="filtroLocalTexto()"
                            (ngModelChange)="filtroLocalTexto.set($event)"
                            (keyup.enter)="aplicarFiltrosLocais()"
                            placeholder="Pesquisar por descrição..."
                        />
                    </app-filtro-campo>
                    <app-filtro-campo label="Tipo">
                        <p-select [options]="tiposLocalFiltro" [ngModel]="filtroLocalTipo()" (ngModelChange)="filtroLocalTipo.set($event)" optionLabel="label" optionValue="value" styleClass="w-full" appendTo="body" />
                    </app-filtro-campo>
                    <app-filtro-campo label="Situação">
                        <p-select [options]="situacoesLocalFiltro" [ngModel]="filtroLocalSituacao()" (ngModelChange)="filtroLocalSituacao.set($event)" optionLabel="label" optionValue="value" styleClass="w-full" appendTo="body" />
                    </app-filtro-campo>
                    <app-filtro-campo label="Ordenação">
                        <p-select [options]="localSortOpcoes" [ngModel]="localSortSelecionado()" (ngModelChange)="onLocalSortCardChange($event)" optionLabel="label" placeholder="Ordenar por..." styleClass="w-full" appendTo="body" />
                    </app-filtro-campo>
                </app-filtros-bar>

                <!-- Barra de status -->
                <div class="flex justify-between items-center gap-3 mb-4">
                    <span class="text-sm text-surface-400 dark:text-surface-500">
                        <span class="font-bold text-surface-700 dark:text-surface-200">{{ totalLocais() }}</span>
                        {{ totalLocais() === 1 ? 'local' : 'locais' }}
                    </span>
                    <app-table-view-switcher [(viewMode)]="locaisView"></app-table-view-switcher>
                </div>

                @if (locaisView() === 'card') {
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        @for (local of locaisPagina(); track local.idLocalReuniao) {
                            <app-card-container>
                                <div class="flex items-start justify-between gap-3 min-w-0">
                                    <div class="flex items-center gap-3 min-w-0">
                                        <span class="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center shrink-0">
                                            <i class="pi pi-map-marker" aria-hidden="true"></i>
                                        </span>
                                        <div class="min-w-0">
                                            <div class="font-semibold leading-tight truncate" [title]="local.dsLocalReuniao">{{ local.dsLocalReuniao || 'Local sem nome' }}</div>
                                            <div class="text-xs text-muted-color mt-0.5">#{{ local.idLocalReuniao }}</div>
                                        </div>
                                    </div>
                                    <p-tag [value]="local.tipo || (getTipoLocal(local) === 'I' ? 'Interno' : 'Externo')" [severity]="getTipoLocal(local) === 'I' ? 'info' : 'secondary'" [rounded]="true"></p-tag>
                                </div>
                                <div class="flex items-center justify-between mt-4 pt-3 border-t border-surface-200 dark:border-surface-700">
                                    <div class="flex items-center gap-2">
                                        <p-toggleswitch [ngModel]="local.ativo" [appCan]="roleGerenciarLocais" (ngModelChange)="alterarStatusLocal(local, $event)"></p-toggleswitch>
                                        <span class="text-xs text-muted-color">{{ local.ativo ? 'Ativo' : 'Inativo' }}</span>
                                    </div>
                                    <div class="flex gap-1">
                                        <p-button
                                            icon="pi pi-pencil"
                                            [appCan]="roleGerenciarLocais"
                                            [text]="true"
                                            [rounded]="true"
                                            size="small"
                                            (click)="editarLocal(local)"
                                            pTooltip="Editar"
                                            tooltipPosition="top"
                                            [ariaLabel]="'Editar ' + (local.dsLocalReuniao || 'local')"
                                        />
                                        <p-button
                                            icon="pi pi-trash"
                                            [appCan]="roleGerenciarLocais"
                                            severity="danger"
                                            [text]="true"
                                            [rounded]="true"
                                            size="small"
                                            [disabled]="local.usado"
                                            (click)="excluirLocal(local)"
                                            pTooltip="Remover"
                                            tooltipPosition="top"
                                            [ariaLabel]="'Remover ' + (local.dsLocalReuniao || 'local')"
                                        />
                                    </div>
                                </div>
                            </app-card-container>
                        } @empty {
                            <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400" role="status">
                                <i class="pi pi-inbox text-5xl mb-3" aria-hidden="true"></i>
                                <span>Nenhum local encontrado.</span>
                            </div>
                        }
                    </div>
                } @else {
                    <p-table
                        [value]="locaisPagina()"
                        [loading]="carregandoLocais()"
                        dataKey="idLocalReuniao"
                        styleClass="p-datatable-sm locais-table"
                        [tableStyle]="{ 'min-width': '48rem' }"
                        [customSort]="true"
                        [sortField]="localSortField()"
                        [sortOrder]="localSortOrder()"
                        (onSort)="onLocalSortChange($event)"
                        stripedRows
                        [ariaLabel]="'Tabela de locais de reunião'"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="dsLocalReuniao">
                                    <strong>Local</strong>
                                    <p-sortIcon field="dsLocalReuniao" />
                                </th>
                                <th class="coluna-status">
                                    <strong>Tipo</strong>
                                </th>
                                <th class="coluna-status">
                                    <strong>Situação</strong>
                                </th>
                                <th class="coluna-acoes text-center">
                                    <strong>Ações</strong>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-local>
                            <tr>
                                <td>
                                    <div class="modelo-nome">
                                        <span class="font-semibold">{{ local.dsLocalReuniao || 'Local sem nome' }}</span>
                                        <small>#{{ local.idLocalReuniao }}</small>
                                    </div>
                                </td>
                                <td class="coluna-status text-center">
                                    <p-tag [value]="local.tipo || (getTipoLocal(local) === 'I' ? 'Interno' : 'Externo')" [severity]="getTipoLocal(local) === 'I' ? 'info' : 'secondary'" [rounded]="true"></p-tag>
                                </td>
                                <td class="coluna-status text-center">
                                    <p-toggleswitch [ngModel]="local.ativo" [appCan]="roleGerenciarLocais" (ngModelChange)="alterarStatusLocal(local, $event)"></p-toggleswitch>
                                </td>
                                <td class="coluna-acoes text-center">
                                    <div class="flex justify-center gap-1">
                                        <p-button
                                            icon="pi pi-pencil"
                                            [appCan]="roleGerenciarLocais"
                                            [text]="true"
                                            [rounded]="true"
                                            size="small"
                                            (click)="editarLocal(local)"
                                            pTooltip="Editar"
                                            tooltipPosition="top"
                                            [ariaLabel]="'Editar ' + (local.dsLocalReuniao || 'local')"
                                        />
                                        <p-button
                                            icon="pi pi-trash"
                                            [appCan]="roleGerenciarLocais"
                                            severity="danger"
                                            [text]="true"
                                            [rounded]="true"
                                            size="small"
                                            [disabled]="local.usado"
                                            (click)="excluirLocal(local)"
                                            pTooltip="Remover"
                                            tooltipPosition="top"
                                            [ariaLabel]="'Remover ' + (local.dsLocalReuniao || 'local')"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="4">
                                    <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                                        <i class="pi pi-inbox text-3xl" aria-hidden="true"></i>
                                        <span class="text-sm">Nenhum local encontrado.</span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                }

                <p-paginator (onPageChange)="onLocalPageChange($event)" [first]="localFirst()" [rows]="localRows()" [totalRecords]="totalLocais()" [rowsPerPageOptions]="[10, 15, 20]" [appendTo]="'body'" />
            </app-card-content>
        }

        @if (abaAtiva() === 'modelos') {
            <app-card-content [icon]="'pi pi-file-edit'" [title]="'Modelos de ata'" [subtitle]="'Modelos disponíveis para geração de atas'" class="col-span-full">
                <button card-header type="button" pButton icon="pi pi-refresh" severity="secondary" [outlined]="true" [loading]="carregandoModelos()" (click)="carregarModelosAta()" aria-label="Recarregar modelos"></button>

                <p-table [value]="modelosAta()" [loading]="carregandoModelos()" styleClass="p-datatable-sm modelos-table" [tableStyle]="{ 'min-width': '42rem' }" stripedRows [ariaLabel]="'Tabela de modelos de ata'">
                    <ng-template pTemplate="header">
                        <tr>
                            <th><strong>Modelo</strong></th>
                            <th class="coluna-status"><strong>Documento</strong></th>
                            <th class="coluna-status"><strong>Ativo</strong></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-modelo>
                        <tr>
                            <td>
                                <div class="modelo-nome">
                                    <span class="font-semibold">{{ modelo.dsModeloAta || 'Modelo sem nome' }}</span>
                                    <small>#{{ modelo.idModeloAta }}</small>
                                </div>
                            </td>
                            <td class="coluna-status text-center">
                                <p-tag [value]="modelo.documentoDisponivel ? 'Disponivel' : 'Ausente'" [severity]="modelo.documentoDisponivel ? 'success' : 'warn'" [rounded]="true"></p-tag>
                            </td>
                            <td class="coluna-status text-center">
                                <p-toggleswitch [ngModel]="modelo.ativo" (ngModelChange)="alterarStatusModelo(modelo, $event)"></p-toggleswitch>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3">
                                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                                    <i class="pi pi-inbox text-3xl" aria-hidden="true"></i>
                                    <span class="text-sm">Nenhum modelo encontrado.</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        }
    </app-card-content>
</section>

<app-seleciona-assunto header="Assuntos" (assuntoSelecionado)="onAssuntoSelecionado($event)" />

<app-seleciona-estrutura header="Estruturas Organizacionais" (estruturaSelecionada)="onEstruturaSelecionada($event)" />

<p-dialog appDialogoPadrao="pi pi-pencil" descricao="Modelo de e-mail enviado pela comissão." [(visible)]="editorEmail.visivel" [header]="editorEmail.titulo" [style]="{ width: '58rem', maxWidth: '95vw' }">
    <textarea pTextarea [(ngModel)]="editorEmail.texto" rows="18" class="w-full editor-email-texto"></textarea>
    <ng-template pTemplate="footer">
        <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="editorEmail = { visivel: false, titulo: '', campo: null, texto: '' }"></button>
        <button type="button" pButton [appCan]="roleEditar" icon="pi pi-check" label="Aplicar" (click)="salvarEditorEmail()"></button>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-map-marker"
    descricao="Local oferecido ao marcar reuniões."
    [visible]="localDialogVisivel()"
    (visibleChange)="localDialogVisivel.set($event)"
    [header]="localForm.idLocalReuniao ? 'Editar local de reuniao' : 'Novo local de reuniao'"
    [style]="{ width: '34rem', maxWidth: '95vw' }"
>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1.5">
            <label for="dsLocalReuniao" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Descrição</label>
            <input id="dsLocalReuniao" pInputText [(ngModel)]="localForm.dsLocalReuniao" maxlength="120" />
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="flex flex-col gap-1.5">
                <label for="tipoLocal" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Tipo</label>
                <p-select inputId="tipoLocal" [options]="tiposLocal" optionLabel="label" optionValue="value" [(ngModel)]="localForm.inInternoExterno" appendTo="body" styleClass="w-full"></p-select>
            </div>
            <div class="linha-toggle mini-toggle mt-5">
                <span>Ativo</span>
                <p-toggleswitch [(ngModel)]="localForm.ativo"></p-toggleswitch>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="localDialogVisivel.set(false)"></button>
        <button type="button" pButton icon="pi pi-save" label="Salvar" [loading]="salvandoLocal()" (click)="salvarLocalReuniao()"></button>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-map-marker"
    descricao="O local deixa de ser oferecido nas reuniões."
    header="Excluir Local de Reunião"
    [visible]="excluirLocalDialogVisivel()"
    (visibleChange)="excluirLocalDialogVisivel.set($event)"
    [style]="{ width: '28rem', border: 'none' }"
    appendTo="body"
>
    <div class="flex flex-col gap-2 py-2">
        <p class="text-sm text-color">
            Deseja realmente excluir o local de reunião <strong>{{ localParaExcluir()?.dsLocalReuniao }}</strong
            >?
        </p>
        <p class="text-xs text-muted-color">Essa ação não poderá ser desfeita.</p>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="excluirLocalDialogVisivel.set(false)"></button>
            <button type="button" pButton icon="pi pi-trash" label="Excluir" severity="danger" (click)="confirmarExcluirLocal()"></button>
        </div>
    </ng-template>
</p-dialog>
